<template>
    <vx-table-row>
        <vx-table-row-item class="vx-hidden xl:vx-inline-block">
            <vx-checkbox v-model="selected" data-test="select"></vx-checkbox>
        </vx-table-row-item>

        <vx-table-row-title class="xl:!vx-col-span-2">
            <div class="vx-flex vx-items-center vx-gap-2">
                <vx-checkbox v-model="selected" data-test="select" class="md:vx-inline-flex xl:vx-hidden"></vx-checkbox>
                <span>{{ fullName }}</span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Phone: </template>
            {{ formatPhoneNumber(props.modelValue.phone) }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Email: </template>
            {{ props.modelValue.email }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Campaign Sends: </template>
            <span v-if="!belongsToCampaign">-</span>
            <vx-icon-loading v-else-if="loadingCompletedCount" class="vx-w-2 vx-h-2" spn></vx-icon-loading>
            <template v-else>{{ completedCount }}</template>
        </vx-table-row-item>

        <vx-table-row-item v-if="pending" class="vx-justify-center">
            <vx-icon-loading class="vx-w-2 vx-h-2"></vx-icon-loading>
        </vx-table-row-item>

        <vx-table-row-buttons v-else>
            <slot name="buttons">
                <vx-button v-if="belongsToCampaign"
                    @click.prevent="emit('remove')"
                    data-test="remove-btn"
                    color="muted"
                    outline>
                    Remove <font-awesome-icon :icon="faCircleMinus" />
                </vx-button>

                <vx-button v-else
                    @click.prevent="emit('add')"
                    data-test="add-btn"
                    color="muted"
                    outline>
                    Add <font-awesome-icon :icon="faCirclePlus" />
                </vx-button>
            </slot>
        </vx-table-row-buttons>

    </vx-table-row>
</template>

<script setup>
import {  faCirclePlus, faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
    VxIconLoading
} from "@voxie/frontend-components";
import contactsClient from '~/services/contactsClient';
import { computed, ref, watch } from 'vue';
import { formatPhoneNumber } from '~/components/filters';
import { VxCheckbox } from '@voxie/frontend-components';

const teamId = Spark.state.currentTeam.id;

const selected = defineModel('selected', {
        type: Boolean,
        required: true,
    }
);

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    campaignId: {
        type: Number,
        required: true,
    },
    pending: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['add', 'remove']);

const fullName = computed(() => {
    const fullName = `${props.modelValue.first_name || ''} ${props.modelValue.last_name || ''}`.trim();
    return fullName || '-';
})

const belongsToCampaign = computed(() => {
    return props.modelValue.campaigns?.filter(campaign => campaign.id === props.campaignId)?.length > 0;
});

const loadingCompletedCount = ref(false);
const completedCount = ref(0);

watch(belongsToCampaign, () => {
    if (belongsToCampaign.value) {
        loadingCompletedCount.value = true;
        contactsClient.contactsCompletedCount(teamId, props.campaignId, props.modelValue.id)
            .then(({ data }) => {
                completedCount.value = data.count;
            })
            .finally(() => {
                loadingCompletedCount.value = false;
            });
    }
}, {
    immediate: true
})

</script>
